import { useState } from "react";
import { api, pct } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import { useLoad, act, Card, Badge, H1, Table, abtn, ainput } from "../../components/admin/ui";

function BrandForm({ onDone }) {
  const [f, setF] = useState({ name: "", slug: "", tagline: "", accent: "#C9A96E", primary: "#0B0C10", categories: "", markup: "" });
  const save = async () => {
    const body = { name: f.name, slug: f.slug, tagline: f.tagline, colors: { primary: f.primary, accent: f.accent }, categories: f.categories.split(",").map((x) => x.trim()).filter(Boolean),
      price_rules: f.markup ? { markup: +f.markup } : {} };
    if (await act(() => api.post("/admin/brands", body), "Marque créée")) onDone();
  };
  const inp = (k, ph, w = "w-40") => <input data-testid={`brand-form-${k}`} placeholder={ph} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${ainput} ${w}`} />;
  return (
    <div className="flex flex-wrap gap-2 mt-4 border-t border-[#1E222D] pt-4">
      {inp("name", "Nom")}{inp("slug", "slug")}{inp("tagline", "Accroche", "w-64")}{inp("categories", "Catégories (a, b)", "w-48")}{inp("markup", "Majoration (ex 0.3)", "w-32")}
      <input type="color" value={f.primary} onChange={(e) => setF({ ...f, primary: e.target.value })} data-testid="brand-form-primary" />
      <input type="color" value={f.accent} onChange={(e) => setF({ ...f, accent: e.target.value })} data-testid="brand-form-accent" />
      <button data-testid="brand-create" onClick={save} className={abtn}>Créer la marque</button>
    </div>
  );
}

export default function BrandsMarkets() {
  const { user } = useApp();
  const [brands, reloadB] = useLoad("/admin/brands");
  const [markets, reloadM] = useLoad("/admin/markets");
  const toggleMarket = async (m, active) => {
    await act(() => api.put(`/admin/markets/${m.code}`, { active, checklist: m.checklist, vat_rate: m.vat_rate, duties_rate: m.duties_rate, fx: m.fx }), `${m.name} ${active ? "activé" : "désactivé"}`);
    reloadM();
  };
  const check = async (m, k) => {
    const checklist = { ...m.checklist, [k]: !m.checklist[k] };
    await act(() => api.put(`/admin/markets/${m.code}`, { active: m.active && Object.values(checklist).every(Boolean), checklist, vat_rate: m.vat_rate, duties_rate: m.duties_rate, fx: m.fx }), "Checklist mise à jour");
    reloadM();
  };
  return (
    <div>
      <H1 sub="Marques multiples sur services centraux partagés (prix, paiements, fournisseurs). Un pays n'est activé que si livraison, paiements, taxes et obligations légales sont vérifiés.">Marques & marchés</H1>
      <Card title="Marques" testid="brands-card">
        <Table testid="brands-table" rows={brands || []} cols={[
          ["Marque", (b) => <span className="flex items-center gap-2"><span className="w-4 h-4 inline-block border border-white/20" style={{ background: b.colors?.accent }} />{b.name}</span>],
          ["Slug", (b) => <span className="font-mono text-xs">/brand/{b.slug}</span>], ["Catégories", (b) => <span className="text-xs">{b.categories.join(", ")}</span>],
          ["Ton", (b) => <span className="text-xs text-slate-400">{b.tone}</span>], ["Majoration", (b) => <span className="font-mono text-xs">{b.price_rules?.markup ? pct(b.price_rules.markup, 0) : "globale"}</span>],
          ["Publiés", (b) => <span className="font-mono">{b.products}</span>], ["Domaine", (b) => <span className="text-xs text-slate-500">{b.domain || "[à configurer]"}</span>],
        ]} />
        {user.role === "owner" && <BrandForm onDone={reloadB} />}
      </Card>
      <div className="mt-4">
        <Card title="Marchés / juridictions" testid="markets-card">
          <Table testid="markets-table" rows={markets || []} cols={[
            ["Pays", (m) => `${m.name} (${m.code})`], ["Devise", (m) => <span className="font-mono text-xs">{m.currency} · fx {m.fx}</span>],
            ["TVA / droits", (m) => <span className="font-mono text-xs">{pct(m.vat_rate)} / {pct(m.duties_rate)}</span>],
            ["Checklist", (m) => <div className="flex gap-1 flex-wrap">{["delivery", "payments", "taxes", "legal"].map((k) => (
              <button key={k} data-testid={`market-check-${m.code}-${k}`} disabled={user.role !== "owner"} onClick={() => check(m, k)} className={`text-[10px] font-mono border px-1.5 py-0.5 ${m.checklist[k] ? "border-emerald-500/40 text-emerald-400" : "border-red-500/40 text-red-400"}`}>{k}</button>
            ))}</div>],
            ["Statut", (m) => <Badge v={m.active ? "active" : "inactif"} testid={`market-status-${m.code}`} />],
            ["", (m) => user.role === "owner" && <button data-testid={`market-toggle-${m.code}`} onClick={() => toggleMarket(m, !m.active)} className={abtn}>{m.active ? "Désactiver" : "Activer"}</button>],
          ]} />
        </Card>
      </div>
    </div>
  );
}
